export const noteAction = note => ({
  type: 'NOTE',
  note,
})
